<!--Page Header-->
<div id="page-head" class="mb-10">
  <div class="container mx-auto">
    <h1>Visa Medical Appointment For {{country}}</h1>
  </div>
</div>
<div class="form-wrap  grid md:grid-cols-1 lg:grid-cols-4  mx-5">
  <form class="lg:col-span-3" [formGroup]="dynamicForm" #form="ngForm">
    <mat-accordion class="form-accordion" multi>
      <mat-expansion-panel *ngFor="let count of countArray; let k=index" [expanded]="step === k" (opened)="setStep(k)">
        <mat-expansion-panel-header>
          <mat-panel-title class="font-bold text-lg ">
            <mat-icon class="mr-3 text-red-700" matPrefix>account_circle</mat-icon>
            Applicant {{k+1}}
          </mat-panel-title>
          <mat-panel-description>
            Please fill all the details
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div formArrayName="applicant{{k}}" class="mt-5">
          <div class="form-container" *ngFor="let control of jsonFormData; let i=index">
            <div [formGroupName]="i">
              <div class="mat-form-field-wrap" *ngIf="[
                        'text',
                        'email',
                        'number',
                        'search',
                        'tel',
                        'url'
                        ].includes(control.type)  && controlVisibility(control, k, i)">

                <mat-form-field appearance="outline" color="primary">
                  <mat-label *ngIf="control.label !== ''">{{ control.label }}</mat-label>
                  <input [placeholder]="control.placeholder" matInput [type]="control.type"
                    [formControlName]="control.name" [required]="isFieldRequired(control,k, i)">
                </mat-form-field>

              </div>
              <div class="mat-form-field-wrap" *ngIf="control.type == 'password'  && controlVisibility(control, k, i)">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label *ngIf="control.label !== ''">{{ control.label }}</mat-label>
                  <input [placeholder]="control.placeholder" matInput [formControlName]="control.name"
                    [type]="hide ? 'password' : 'text'">
                  <mat-icon matSuffix (click)="hide = !hide"
                    fontIcon="{{hide ? 'visibility_off' : 'visibility'}}"></mat-icon>
                </mat-form-field>
              </div>
              <div class="mat-form-field-wrap" *ngIf="control.type == 'radio' && controlVisibility(control, k, i)">
                <label [ngClass]="{'invalid': control.validators.required ==
                'required' && fieldControlCheck(k,i)&& form.submitted}" *ngIf="control.label !== ''"
                  id="form-radio-group-label">{{control.validators.required ==
                  'required'? control.label+' *' : control.label }}</label>
                <span class="radio-placeholder mt-1 font-light block text-sm" *ngIf="control.placeholder !== ''"
                  id="form-radio-group-label">{{control.placeholder
                  }}</span>
                <mat-radio-group color="primary" aria-labelledby="form-radio-group-label" class="form-radio-group"
                  [formControlName]="control.name">
                  <mat-radio-button class="form-radio-button" *ngFor="let value of control.values"
                    [value]="value.value">
                    {{value.label}}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="mat-form-field-wrap" *ngIf="control.type == 'select'  && controlVisibility(control, k, i)">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label *ngIf="control.label !== ''">{{ control.label }}</mat-label>
                  <mat-select [placeholder]="control.placeholder" [formControlName]="control.name">
                    <mat-option *ngFor="let value of control.values" [value]="value.value">
                      {{value.label}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="mat-form-field-wrap" *ngIf="control.type == 'textarea'  && controlVisibility(control, k, i)">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label *ngIf="control.label !== ''">{{ control.label }}</mat-label>
                  <textarea [placeholder]="control.placeholder" matInput [formControlName]="control.name">  </textarea>
                </mat-form-field>
              </div>
              <div class="mat-form-field-wrap" *ngIf="control.type == 'file'  && controlVisibility(control, k, i)">
                <label *ngIf="control.label !== ''">{{control.validators.required ==
                  'required'? control.label+' *' : control.label }}</label>

                <div class="file-preview p-2"
                  *ngIf="(editFormData?.form_elements.length > 0) && (getEditFileDetails(control.name, 'isVisible') == true) && getEditFileDetails(control.name, 'extension') !== 'pdf'">
                  <div class="shrink-0">
                    <img alt="file" class="object-cover h-3/6 w-full" [src]="getEditFileDetails(control.name, 'url')">
                  </div>
                  <button class="mt-5" mat-stroked-button color="warn" aria-label="Browse"
                    (click)="toggleUpload(control,i)">
                    Change
                  </button>
                </div>
                <div class="file-preview p-2"
                  *ngIf="(editFormData?.form_elements.length > 0) && getEditFileDetails(control.name, 'isVisible') == true && getEditFileDetails(control.name, 'extension') == 'pdf'">
                  <div class="">
                    <p class="break-all text-center">Please click on View to open the PDF file you've uploaded.</p>
                  </div>
                  <div class="flex justify-around">
                    <button class="mt-5 mr-3" mat-raised-button color="warn" aria-label="View"
                      (click)="viewPdf(getEditFileDetails(control.name, 'url'))">
                      View
                    </button> <button class="mt-5 ml-3" mat-stroked-button color="warn" aria-label="Change"
                      (click)="toggleUpload(control,i)">
                      Change
                    </button>
                  </div>

                </div>
                <div class="drop-zone" [ngClass]="{'required-file': displayIsFileFieldRequiredAndValid(control, k, i)}"
                  *ngIf="getEditFileDetails(control.name, 'isVisible') == false || editFormData?.form_elements.length < 1">
                  <p class="drop-zone-text  text-center"
                    *ngIf=" this.getFileName(control,k) == '' && this.getFileName(control,k) !== 'invalid'">
                    {{control.placeholder}}
                  </p>
                  <p class="text-center break-all"
                    *ngIf=" this.getFileName(control,k) !== '' && this.getFileName(control,k) !== 'invalid'">
                    {{this.getFileName(control,k)}}
                  </p>
                  <p class="text-center my-3 text-sm text-red-700"
                    *ngIf="!this.getFileValidation(control, k) && this.getFileName(control,k) == 'invalid'"> The
                    selected file is over {{control.validators.maxsize}} MB. Maximum size allowed is
                    {{control.validators.maxsize}} MB</p>

                  <input accept="{{getFileExtensions(control.validators.accept || '')}}" class="file-input" type="file"
                    #fileUpload ng2FileSelect [multiple]="false"
                    (onFileSelected)="onFileSelected($event, control, k, i)" /><br />
                  <div class="file-upload">
                    <button mat-raised-button color="primary" aria-label="Browse" (click)="fileUpload.click()">
                      Browse files
                    </button>
                  </div>
                </div>


              </div>
              <div class="mat-form-field-wrap"
                *ngIf="control.type == 'date' && control.name !=='dateofbirth' && control.name !=='passportexpirydate' && controlVisibility(control, k, i)">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label *ngIf="control.label !== ''">{{ control.label }}</mat-label>
                  <input [placeholder]="control.placeholder" matInput readonly [formControlName]="control.name"
                    [matDatepicker]="picker">
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="mat-form-field-wrap"
                *ngIf="control.type == 'date' && control.name =='dateofbirth' && controlVisibility(control, k, i)">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label *ngIf="control.label !== ''">{{ control.label }}</mat-label>
                  <input [placeholder]="control.placeholder" matInput [max]="dateOfBirths[k].dobMaxDate"
                    [min]="dateOfBirths[k].dobMinDate" readonly [formControlName]="control.name"
                    [matDatepicker]="picker">
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error class="mt-1 text-sm float-right">Please enter a valid date</mat-error>
                </mat-form-field>
              </div>
              <div class="mat-form-field-wrap"
                *ngIf="control.type == 'date' && control.name =='passportexpirydate'  && controlVisibility(control, k, i)">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label *ngIf="control.label !== ''">{{ control.label }}</mat-label>
                  <input [placeholder]="control.placeholder" matInput [min]="passportMinDate" readonly
                    [formControlName]="control.name" [matDatepicker]="picker">
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <mat-action-row *ngIf="totalCount > 1">
          <button *ngIf="k > 0" mat-button color="warn" (click)="prevStep()">Previous</button>
          <button *ngIf="k < totalCount-1" mat-button color="primary" (click)="nextStep()">Next</button>
        </mat-action-row>
      </mat-expansion-panel>
      <div class="">
        <mat-checkbox color="primary" [(ngModel)]="isChecked" [ngModelOptions]="{standalone: true}"
          [checked]="isChecked" class="mt-3">
          I declare that all the information entered in the form is true and correct to the best of my knowledge. *
        </mat-checkbox>
      </div>
      <div class="button-wrapper text-center w-4/5 my-8 mx-auto">
        <p class="my-3 text-sm text-red-700"
          *ngIf="passportError !== '' || countValidationErrorMsg !=='' || formError !==''">
          {{passportError}} {{countValidationErrorMsg}} {{formError}}</p>
        <button [disabled]="!isChecked" mat-flat-button color="primary"
          (click)="onSubmit(dynamicForm.value, dynamicForm.valid,$event)">
          <span>Submit</span>
        </button>
      </div>
    </mat-accordion>
  </form>
  <div
    class="required-text lg:col-span-1 mx-auto my-5 xs:mx-auto xs:my-5 sm:mx-auto sm:my-5 md:mx-auto md:my-5 lg:mx-5 lg:my-0">
    <div [innerHTML]="requiredHtml">
    </div>
  </div>
</div>

    <!--Mat Dialog to display message-->
    <ng-template #ocrDialog let-data>
      <h2 mat-dialog-title class="mb-2 font-semibold border-b-1 attention-title">Attention!</h2>
      <div mat-dialog-content>{{ data.message }}</div>
      <div class="flex justify-center ">
        <mat-dialog-actions class="text-center justify-center" id="mdc-close-btn">
            <button class="mb-3 place-self-center" mat-flat-button color="primary" matDialogClose="yes">Close</button>
        </mat-dialog-actions>
      </div>
  </ng-template>
